(() => {
  if (window.FuntouchRoutineFeatureMobile) {
    window.FuntouchRoutineFeatureMobile.initializeAllSliders(document);
    return;
  }

  const sliderSelector = '[data-routine-mobile-slider]';
  const slideSelector = '[data-routine-mobile-slide]';
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  const setActiveSlide = (slider, activeSlide) => {
    slider.querySelectorAll(slideSelector).forEach((slide) => {
      slide.classList.toggle('is-active', slide === activeSlide);
    });
  };

  const getNearestSlide = (slider) => {
    const slides = Array.from(slider.querySelectorAll(slideSelector));
    const sliderRect = slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + sliderRect.width / 2;

    return slides.reduce((nearest, slide) => {
      const slideRect = slide.getBoundingClientRect();
      const distance = Math.abs(slideRect.left + slideRect.width / 2 - sliderCenter);

      if (!nearest || distance < nearest.distance) {
        return { slide, distance };
      }

      return nearest;
    }, null)?.slide;
  };

  const centerSlide = (slider, slide, behavior = 'auto') => {
    if (!mobileMedia.matches || !slide) return;

    const sliderRect = slider.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    const left = slider.scrollLeft
      + slideRect.left
      - sliderRect.left
      - (sliderRect.width - slideRect.width) / 2;

    slider.scrollTo({
      left: Math.max(0, left),
      behavior,
    });
  };

  const initializeSlider = (slider) => {
    if (slider.dataset.routineMobileInitialized === 'true') return;

    const slides = Array.from(slider.querySelectorAll(slideSelector));
    if (!slides.length) return;

    slider.dataset.routineMobileInitialized = 'true';
    let animationFrame = 0;

    const updateActiveSlide = () => {
      animationFrame = 0;
      if (!mobileMedia.matches) return;

      const nearestSlide = getNearestSlide(slider);
      if (nearestSlide) setActiveSlide(slider, nearestSlide);
    };

    const requestActiveSlideUpdate = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(updateActiveSlide);
    };

    slider.addEventListener('scroll', requestActiveSlideUpdate, { passive: true });

    const handleViewportChange = () => {
      if (!mobileMedia.matches) return;

      const activeSlide = slider.querySelector(`${slideSelector}.is-active`) || slides[Math.floor(slides.length / 2)];
      centerSlide(slider, activeSlide);
      requestActiveSlideUpdate();
    };

    window.addEventListener('resize', handleViewportChange, { passive: true });

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const initialSlide = slider.querySelector(`${slideSelector}.is-active`) || slides[Math.floor(slides.length / 2)];
        setActiveSlide(slider, initialSlide);
        centerSlide(slider, initialSlide);
        requestActiveSlideUpdate();
      });
    });
  };

  const initializeAllSliders = (scope = document) => {
    if (scope.matches?.(sliderSelector)) initializeSlider(scope);
    scope.querySelectorAll?.(sliderSelector).forEach(initializeSlider);
  };

  window.FuntouchRoutineFeatureMobile = { initializeAllSliders };

  const start = () => initializeAllSliders(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllSliders(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.(slideSelector);
    const slider = slide?.closest(sliderSelector);

    if (!slider || !slide || !mobileMedia.matches) return;

    setActiveSlide(slider, slide);
    centerSlide(slider, slide, 'smooth');
  });
})();
